import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ContentPromoVideo = class ContentPromoVideo extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo';
	}
	
	constructor(element) {
		super(element);
		
		// Resize video
		this.scaleVideoContainer();
		this.initBannerVideoSize('.video-container .poster img');
		this.initBannerVideoSize('.video-container .filter');
		//this.initBannerVideoSize('.video-container video');
		
		// Video Pause/Play 
		var video = document.getElementById("bgvid");
		$(video).click(function(e){
			var $this = $(e.target);
			video[video.paused ? 'play' : 'pause']();
			$this.prev().toggleClass('hidden');
			//console.log('Paused:' + $(video).prop('paused'))
		}); 
		
		$('.play-video').click(function(e){
			var $this = $(e.target);
			video[video.paused ? 'play' : 'pause']();
			$this.addClass('hidden');
			//console.log('Paused:' + $(video).prop('paused'))
		}); 
	}
	
	render() {
		
	}
	
	scaleVideoContainer() {
		var height = $(window).height()-129;
		var unitHeight = parseInt(height) + 'px';
		$('.fa-content-promo--videocomponent').css('height',unitHeight);
	}
	
	initBannerVideoSize(element){
		$(element).each(function(e){
			var $this = $(e.target);
			$this.data('height', $(this).height());
			$this.data('width', $(this).width());
		});
		
		this.scaleBannerVideoSize(element);
	}
	
	scaleBannerVideoSize(element){
		var windowWidth = $(window).width(),
			windowHeight = $(window).height(),
			videoWidth,
			videoHeight;
			
		//console.log(windowHeight);
		
		$(element).each(function(){
			var videoAspectRatio =  $(this).height()/ $(this).width(),
				windowAspectRatio = windowHeight/windowWidth;
			
			if (videoAspectRatio > windowAspectRatio) {
				videoWidth = windowWidth;
				videoHeight = videoWidth * videoAspectRatio;
				$(this).css({'top' : -(videoHeight - windowHeight) / 2 + 'px', 'margin-left' : 0});
			} else {
				videoHeight = windowHeight;
				videoWidth = videoHeight / videoAspectRatio;
				$(this).css({'margin-top' : 0, 'margin-left' : -(videoWidth - windowWidth) / 2 + 'px'});
			}
			
			$(this).width(videoWidth).height(videoHeight);
			$('.fa-content-promo--videocomponent .video-container video').addClass('fadeIn animated');
		});
	}
};

$(function() {
	var cwContentPromoVideo = new Snappy.Component.ContentPromoVideo();
});


// WEBPACK FOOTER //
// ./components/contentPromoVideo/scripts/contentPromoVideo.js